import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

const useStyles = makeStyles({
  button: {
    backgroundColor: "#216174",
    borderRadius: 14,
    color: "#FFF",
    fontSize: 12,
    height: 32,
    width: 120,
    // margin: 5,
  },
});

const MyPageButton = (props) => {
  const classes = useStyles();
  return (
    <Button
      className={classes.button}
      startIcon={<AccountCircleIcon />}
      variant="contained"
      onClick={() => props.onClick()}
    >
      {props.label}
    </Button>
  );
};
export default MyPageButton;
